<template>
  <div class="chartdiv">
    <highcharts :options="chartOptions" ref="chart"></highcharts>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import Exporting from "highcharts/modules/exporting";
import Annotation from "highcharts/modules/annotations.js";
import Highcharts from "highcharts";
Annotation(Highcharts);
Exporting(Highcharts);
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import { mapState, mapGetter, mapActions } from "vuex";
import MomentTimeZone from "moment-timezone";
import * as turf from "@turf/turf";

export default {
  name: "powerCarChartHigh",
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      train_no: null,
      errors: [],
      dist: [],
      chart_data: [],
      wasClicked: false,
      prevDist: 0,
      prevTime: 0,
      msgAnnotations: {},
      chartOptions: {
        chart: {
          events: {
            load() {
              this.showLoading();
            },
            // selection: (event) => {
            //   console.log(event.target.series[0].data)
            //   if (event.xAxis) {
            //     var p = {
            //       from: moment(event.xAxis[0].min).format("YYYY-MM-DD HH:mm:ss"),
            //       to: moment(event.xAxis[0].max).format("YYYY-MM-DD HH:mm:ss"),
            //       device_id: this.curDeviceId
            //     }
            //     console.log(p)
            //     window.alert(p)
            //     axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            //     axios.get(`${process.env.VUE_APP_API_URL}/timetable/tc/pos_dist`, {
            //         params: p
            //       })
            //       .then(response => {
            //         var start
            //         console.log(response.data)
            //       })
            //       .catch(e => {
            //         console.log(e)
            //       })
            //   }
            // }
          },
          height: "48%",
          type: "line",
          zoomType: "x",
          panning: true,
          panKey: "shift",
        },
        title: {
          text: "Speed Chart(drag select to zoom, press shit key to pan)",
        },

        time: {
          timezone: "Asia/Kolkata",
        },
        xAxis: {
          type: "datetime",
          labels: {
            formatter: function() {
              // var lt = moment(this.value).format("YYYY-MM-DD HH:mm:ss")
              // var testDateUtc = moment.utc(lt);
              // var localDate = moment(testDateUtc).local();
              return moment.utc(this.value).format("HH:mm:ss");
            },
          },
          title: {
            text: "Time",
          },
        },
        defs: {
          marker0: {
            tagName: "marker",
            render: false, // if false it does not render the element to the dom
            id: "custom-shape",
            children: [
              {
                tagName: "path",
                d:
                  "M 10,0 C 0,0 0,10 10,10 C 12.5,7.5 12.5,7.5 20,5 C 12.5,2.5 12.5,2.5 10,0 Z",
              },
            ],
            markerWidth: 40,
            markerHeight: 40,
            refX: 20,
            refY: 5,
          },
          marker1: {
            children: [
              {
                tagName: "circle",
                r: 9,
                cx: 11,
                cy: 11,
                fill: "rgba(224, 101, 0, 0.6",
              },
              {
                tagName: "circle",
                r: 10,
                cx: 11,
                cy: 11,
                fill: "none",
                "stroke-width": 2,
                stroke: "black",
              },
            ],
            tagName: "marker",
            id: "circle",
            markerWidth: 25,
            markerHeight: 25,
            refX: 10,
            refY: 10,
          },
        },

        // tooltip: {
        //   formatter: function() {
        //     // var lt = moment(this.x).format("YYYY-MM-DD HH:mm:ss")
        //     // var testDateUtc = moment.utc(lt);
        //     // var localDate = moment(testDateUtc).local();
        //     // console.log(this)
        //     if (this.series.userOptions.name == 'speed') {
        //       return 'Speed ' + this.y + ' KMPH, Time ' + moment.utc(this.x).format("HH:mm:ss")
        //     } else {
        //       return 'Distance ' + this.y + ' KM, Time ' + moment.utc(this.x).format("HH:mm:ss")
        //     }
        //   }
        //   },
        yAxis: {
          title: {
            text: "Speed(KMPH)",
          },
          min: 0,
        },
        annotations: [
          {
            shapes: [
              {
                points: [{ x: 100, y: 100 }, { x: 200, y: 100 }, "1"],
                type: "path",
                fill: "none",
                stroke: "red",
                markerStart: "circle",
                markerEnd: "custom-shape",
              },
            ],
          },
        ],
        series: [
          {
            name: "Speed",
            data: [], // sample data
            zones: [
              {
                value: 2,
                color: "#FF0000",
              },
              {
                value: 15,
                color: "#FF7F00",
              },
              {
                value: 40,
                color: "#FFD700",
              },
              {
                value: 60,
                color: "#9ACD32",
              },
              {
                value: 80,
                color: "#00FF00",
              },
              {
                value: 90,
                color: "#008080",
              },
              {
                value: 105,
                color: "#FF00FF",
              },
              {
                value: 125,
                color: "#8A2BE2",
              },
              {
                color: "#00BFFF",
              },
            ],
          },
        ],
      },
    };
  },

  mounted() {
    window.moment = moment;
    MomentTimeZone();
    this.fillData();
  },
  computed: {
    ...mapState([
      "curDeviceId",
      "curDeviceName",
      "curTrainNo",
      "curTrainDate",
      "curOrg",
      "curArr",
      "curDest",
      "curDep",
      "actDep",
      "actArr",
      "curPosStartId",
      "curPosDestId",
      "curPositions",
    ]),
  },
  beforeDestroy() {
    this.updateCurTrainNo(null);
    this.updateCurDeviceId(null);
  },
  methods: {
    ...mapActions([
      "updateCurDeviceId",
      "updateCurDeviceName",
      "updateCurTrainNo",
      "updateCurTrainDate",
      "updateCurOrg",
      "updateCurArr",
      "updateCurDest",
      "updateCurDep",
      "updateActDep",
      "updateActArr",
    ]),
    fillData() {
      var p = {
        train_date: moment(this.curTrainDate).format("YYYY-MM-DD"),
        train_no: this.curTrainNo,
        device_id: this.curDeviceId,
        org: this.curOrg,
        dep: moment(this.curDep).format(),
        dest: this.curDest,
        arr: moment(this.curArr)
          .add(30, "m")
          .format(),
        pos_start_id: this.curPosStartId,
        pos_dest_id: this.curPosDestId,
      };
      //    console.log(p)
      this.train_no = this.curTrainNo;
      var that = this;
      axios.defaults.headers.common["Authorization"] = localStorage.getItem(
        "jwtToken"
      );
      axios
        .get(`${process.env.VUE_APP_API_URL}/timetable/tc/positions`, {
          params: p,
        })
        .then((response) => {
          console.log(response.data);
          var speed_data = [];
          var time_data = [];
          var series_data = [];
          var dist_data = [];
          /*
| 2023-06-12 15:03:46 | {"type":14,"result":"Vl1A:0.00,Vl2A:0.00,Vl3A:0.00,I1A:0.00,I2A:0.00,I3A:0.00,kWtA:272.32,
kWhImA:197121.17,kWhExA:2730.46,FuelA:0.000","distance":0.0,"totalDistance":2.4364084212E8,"motion":true}  |
*/
          var Vl1A = [];
          var Vl2A = [];
          var Vl3A = [];

          var Vl1B = [];
          var Vl2B = [];
          var Vl3B = [];

          var I1A = [];
          var I2A = [];
          var I3A = [];

          var I1B = [];
          var I2B = [];
          var I3B = [];
          var HzA = [];
          var HzB = [];
          var kWtA = [];
          var kWtB = [];
          var FuelA = [];
          var FuelB = [];
          var kWhImA = [];
          var kWhImB = [];
          var kWhExA = [];
          var kWhExB = [];

          var kWhImMin = 0;
          var kWhImMax = 0;

          var kWhExMin = 0;
          var kWhExMax = 0;

          var FuelMin = 0;
          var FuelMax = 0;

          var dist = 0;
          var dist_0 = JSON.parse(response.data[0]["attributes"])[
            "totalDistance"
          ];
          var maxSpeed = 0;
          var start_pt = turf.point([
            response.data[0]["longitude"],
            response.data[0]["latitude"],
          ]);
          // for (i = 0; i < response.data.length; i++) {
          var k = 0;
          _.forEach(response.data, function(o) {
            var speed = o.speed;
            switch (o.deviceid) {
              case 3:
              case 10:
              case 11:
              case 13:
                break;
              default:
                speed = that.round(speed * 1.852, 2);
            }
            if (speed > maxSpeed) {
              maxSpeed = speed;
            }
            speed_data.push(speed);
            time_data.push(o.fixtime);
            series_data.push([new Date(o.fixtime).getTime(), speed]);
            // dist = JSON.parse(o['attributes'])['totalDistance'] - dist_0
            // dist = dist / 1000
            if (k > 0) {
              start_pt = turf.point([
                response.data[k - 1].longitude,
                response.data[k - 1].latitude,
              ]);
            }

            var cur_pt = turf.point([
              response.data[k].longitude,
              response.data[k].latitude,
            ]);
            dist =
              dist + turf.distance(start_pt, cur_pt, { units: "kilometers" });
            // console.log(dist)
            dist_data.push([
              new Date(o.fixtime).getTime(),
              that.round(dist, 3),
            ]);
            that.dist.push({
              time: new Date(o.fixtime).getTime(),
              dist: that.round(dist, 3),
            });
            that.chart_data.push({
              time: new Date(o.fixtime).getTime(),
              dist: that.round(dist, 3),
              speed: speed,
            });
            /* Format for powercar data send thorugh traccker
"{\"V12\":431.47,\"V22\":431.55,\"V32\":431.94,\"I12\":1,\"FuelB\": 50.00,\"WhIm2\":0.02,\"WhEx2\":2444364.00}"
{"Vl1A":0.00,"Vl2A":0.00,"Vl3A":0.00,I1A:0.00,I2A:0.00,I3A:0.00,kWtA:0.00,FuelA:0.00,kWhImA:0.00,kWhExA:0.00}
*/
            // Parameters- {A:[V1,V2,V3,I1,I2,I3,Power,Frequency,Unit Import,Unit Export,Fuel Flow],B:[V1,V2,V3,I1,I2,I3,Power,Frequency,Unit Import,Unit Export,Fuel Flow]}
            // Units- {A:[V,V,V,A,A,A,kW,Hz,kWh,kWh,L],B:[V,V,V,A,A,A,kW,Hz,kWh,kWh,L]}
            var rj = JSON.parse(o["attributes"]);
            var r = rj.result;
            // console.log(r)
            if (r) {
              r = r.replace(/A/, '"A"');

              r = r.replace(/B/, '"B"');

              console.log(r);
              try {
                r = JSON.parse(r);
              } catch (e) {
                console.log(e);
              }

              if (r.A) {
                Vl1A.push([
                  new Date(o.fixtime).getTime(),
                  that.round(r.A[0], 3),
                ]);

                Vl2A.push([
                  new Date(o.fixtime).getTime(),
                  that.round(r.A[1], 3),
                ]);

                Vl3A.push([
                  new Date(o.fixtime).getTime(),
                  that.round(r.A[2], 3),
                ]);
                I1A.push([
                  new Date(o.fixtime).getTime(),
                  that.round(r.A[3], 3),
                ]);
                I2A.push([
                  new Date(o.fixtime).getTime(),
                  that.round(r.A[4], 3),
                ]);

                I3A.push([
                  new Date(o.fixtime).getTime(),
                  that.round(r.A[5], 3),
                ]);

                kWtA.push([
                  new Date(o.fixtime).getTime(),
                  that.round(r.A[6], 3),
                ]);
                HzA.push([
                  new Date(o.fixtime).getTime(),
                  that.round(r.A[7], 3),
                ]);
                kWhImA.push([
                  new Date(o.fixtime).getTime(),
                  that.round(r.A[8], 3),
                ]);
                if (k == 0) {
                  kWhImMin = that.round(r.A[8], 3);
                }
                if (kWhImMin > r.A[8]) {
                  kWhImMin = that.round(r.A[8], 3);
                }
                if (kWhImMax < r.A[8]) {
                  kWhImMax = that.round(r.A[8], 3);
                }
                kWhExA.push([
                  new Date(o.fixtime).getTime(),
                  that.round(r.A[9], 3),
                ]);
                if (k == 0) {
                  kWhExMin = that.round(r.A[9], 3);
                }
                if (kWhExMin > r.A[9]) {
                  kWhExMin = that.round(r.A[9], 3);
                }
                if (kWhExMax < r.A[9]) {
                  kWhExMax = that.round(r.A[9], 3);
                }
                FuelA.push([
                  new Date(o.fixtime).getTime(),
                  that.round(r.A[10], 3),
                ]);
                if (k == 0) {
                  FuelMin = that.round(r.A[10], 3);
                }
                if (FuelMin > r.A[10]) {
                  FuelMin = that.round(r.A[10], 3);
                }
                if (FuelMax < r.A[10]) {
                  FuelMax = that.round(r.A[10], 3);
                }
              }
              if (r.B) {
                Vl1B.push([
                  new Date(o.fixtime).getTime(),
                  that.round(r.B[0], 3),
                ]);

                Vl2B.push([
                  new Date(o.fixtime).getTime(),
                  that.round(r.B[1], 3),
                ]);

                Vl3B.push([
                  new Date(o.fixtime).getTime(),
                  that.round(r.B[2], 3),
                ]);
                I1B.push([
                  new Date(o.fixtime).getTime(),
                  that.round(r.B[3], 3),
                ]);
                I2B.push([
                  new Date(o.fixtime).getTime(),
                  that.round(r.B[4], 3),
                ]);
                I3B.push([
                  new Date(o.fixtime).getTime(),
                  that.round(r.B[5], 3),
                ]);
                kWtB.push([
                  new Date(o.fixtime).getTime(),
                  that.round(r.B[6], 3),
                ]);
                HzB.push([
                  new Date(o.fixtime).getTime(),
                  that.round(r.B[7], 3),
                ]);
                kWhImB.push([
                  new Date(o.fixtime).getTime(),
                  that.round(r.B[8], 3),
                ]);
                if (kWhImMin > r.B[8]) {
                  kWhImMin = that.round(r.B[8], 3);
                }
                if (kWhImMax < r.B[8]) {
                  kWhImMax = that.round(r.B[8], 3);
                }
                kWhExB.push([
                  new Date(o.fixtime).getTime(),
                  that.round(r.B[9], 3),
                ]);
                if (kWhExMin > r.B[9]) {
                  kWhExMin = that.round(r.B[9], 3);
                }
                if (kWhExMax < r.B[9]) {
                  kWhExMax = that.round(r.B[9], 3);
                }
                FuelB.push([
                  new Date(o.fixtime).getTime(),
                  that.round(r.B[10], 3),
                ]);
                if (FuelMin > r.B[10]) {
                  FuelMin = that.round(r.B[10], 3);
                }
                if (FuelMax < r.B[10]) {
                  FuelMax = that.round(r.B[10], 3);
                }
              }
            }
            k++;
          });
          console.log(kWhImMin, kWhImMax, kWhExMin, kWhExMax, FuelMin, FuelMax);

          // var kWhImAmin = _.minBy(kWhImA, function(o) {
          //   return o[1];
          // });
          // var kWhImBmin = _.minBy(kWhImB, function(o) {
          //   return o[1];
          // });
          // kWhImMin = _.min([kWhImAmin, kWhImBmin]);
          // var kWhImAmax = _.maxBy(kWhImA, function(o) {
          //   return o[1];
          // });
          // var kWhImBmax = _.maxBy(kWhImB, function(o) {
          //   return o[1];
          // });
          // kWhImMax = _.max([kWhImAmax, kWhImBmax]);

          // var kWhExAmin = _.minBy(kWhExA, function(o) {
          //   return o[1];
          // });
          // var kWhExBmin = _.minBy(kWhExB, function(o) {
          //   return o[1];
          // });
          // kWhExMin = _.min([kWhExAmin, kWhExBmin]);

          // var kWhExAmax = _.maxBy(kWhExA, function(o) {
          //   return o[1];
          // });
          // var kWhExBmax = _.maxBy(kWhExB, function(o) {
          //   return o[1];
          // });
          // kWhImMax = _.max([kWhExAmax, kWhExmBmax]);

          // var FuelMin = _.minBy(Fuel, function(o) {
          //   return o[1];
          // });

          // var FuelMax = _.maxBy(Fuel, function(o) {
          //   return o[1];
          // });

          // console.log(dist_data)
          // this.dist = dist_data
          // console.log(this.dist)
          // console.log(time_data,new Date(time_data[10]).getTime(),new Date(time_data[100]).getTime())

          axios.defaults.headers.common["Authorization"] = localStorage.getItem(
            "jwtToken"
          );
          axios
            .get(`${process.env.VUE_APP_API_URL}/timetable/tc/punct`, {
              params: p,
            })
            .then((response) => {
              // console.log(response)
              var ctr = response.data;
              if (ctr.length == 0 && this.curPositions.length > 0) {
                ctr = this.curPositions;
              }
              var plot_bands = [];
              var i = 1;
              _.forEach(ctr, function(o) {
                plot_bands.push({
                  color: that.makeColor(i++, response.data.length), // Color value
                  from: new Date(time_data[o.start_pos]).getTime(), // Start of the plot band
                  to: new Date(time_data[o.end_pos]).getTime(), // End of the plot band
                  label:
                    o.late_in == null
                      ? {
                          text: o.stn_code, // Content of the label.
                          align: "center", // Positioning of the label.
                        }
                      : {
                          text:
                            o.stn_code +
                            "<br>" +
                            '<span style="font-size: 80%;">' +
                            o.late_in +
                            "</span>" +
                            "<br>" +
                            '<span style="font-size: 80%;">' +
                            o.late_out +
                            "</span>", // Content of the label.
                          align: "center", // Positioning of the label.
                        },
                });
              });
              // console.log(response.data)
              this.chartOptions = {
                subtitle: {
                  text: `Date: ${moment(this.curTrainDate).format(
                    "DD/MM/YYYY"
                  )}, Train No: ${this.train_no} , Rake: ${this.curDeviceName}`,
                },
                xAxis: {
                  categories: time_data,
                  plotBands: plot_bands,
                  crosshair: true,
                },

                tooltip: {
                  formatter: function() {
                    // The first returned item is the header, subsequent items are the
                    // points
                    return [
                      "<b>" +
                        moment.utc(this.x).format("HH:mm:ss") +
                        " " +
                        "</b>",
                    ].concat(
                      this.points
                        ? this.points.map(function(point) {
                            return point.series.name + ": " + point.y + " ";
                          })
                        : []
                    );
                  },
                  shared: true,
                  crosshairs: true,
                },
                yAxis: [
                  {
                    // 0
                    showEmpty: false,
                    title: {
                      text: "Speed(KMPH)",
                    },
                    min: 0,
                    max: maxSpeed,
                  },
                  {
                    // 1
                    showEmpty: false,
                    title: {
                      text: "Distance(KM)",
                      style: {
                        color: "#FF0000",
                      },
                    },
                    min: 0,
                    max: dist,

                    labels: {
                      format: "{value}",
                      style: {
                        color: "#FF0000",
                      },
                    },
                    opposite: true,
                  },
                  {
                    // 2
                    showEmpty: false,
                    title: {
                      text: "Voltage(V)",
                      style: {
                        color: "#FF4500",
                      },
                    },
                    min: 0,
                    max: 1200,

                    labels: {
                      format: "{value}",
                      style: {
                        color: "#FF4500",
                      },
                    },
                    opposite: true,
                  },
                  {
                    // 3
                    showEmpty: false,
                    title: {
                      text: "Current(A)",
                      style: {
                        color: "#0000FF",
                      },
                    },
                    min: 0,
                    max: 200,

                    labels: {
                      format: "{value}",
                      style: {
                        color: "#0000FF",
                      },
                    },
                    opposite: true,
                  },
                  {
                    // 4
                    showEmpty: false,
                    title: {
                      text: "Power(kW)",
                      style: {
                        color: "#FFA500", //Power,Frequency,Unit Import,Unit Export,Fuel    Flow],B:[V1,V2,V3,I1,I2,I3,Power,Frequency,Unit Import,Unit Export,Fuel Flow
                      },
                    },
                    min: 0,
                    max: 200,

                    labels: {
                      format: "{value}",
                      style: {
                        color: "#FFA500",
                      },
                    },
                    opposite: true,
                  },
                  {
                    // 5
                    showEmpty: false,
                    title: {
                      text: "Frequency(Hz)",
                      style: {
                        color: "#FFA500",
                      },
                    },
                    min: 0,
                    max: 100,

                    labels: {
                      format: "{value}",
                      style: {
                        color: "#FFA500",
                      },
                    },
                    opposite: true,
                  },
                  {
                    // 6
                    showEmpty: false,
                    title: {
                      text: "Unit Import(KWh)",
                      style: {
                        color: "#FF00FF",
                      },
                    },
                    min: kWhImMin,
                    max: kWhImMax,

                    labels: {
                      format: "{value}",
                      style: {
                        color: "#FF00FF",
                      },
                    },
                    opposite: true,
                  },
                  {
                    // 7
                    showEmpty: false,
                    title: {
                      text: "Unit Export(kWh)",
                      style: {
                        color: "#00FF7F",
                      },
                    },
                    min: kWhExMin,
                    max: kWhExMax,

                    labels: {
                      format: "{value}",
                      style: {
                        color: "#00FF7F",
                      },
                    },
                    opposite: true,
                  },
                  {
                    // 8
                    showEmpty: false,
                    title: {
                      text: "Fuel Flow(L)",
                      style: {
                        color: "#9400D3",
                      },
                    },
                    min: FuelMin,
                    max: FuelMax,

                    labels: {
                      format: "{value}",
                      style: {
                        color: "#9400D3",
                      },
                    },
                    opposite: true,
                  },
                ],
                annotations: [
                  {
                    shapes: [
                      {
                        points: [
                          { x: 1566429328000, y: 50 },
                          { x: 1566429328000, y: 0 },
                          "1",
                        ],
                        type: "path",
                        fill: "none",
                        stroke: "red",
                        markerStart: "circle",
                        markerEnd: "custom-shape",
                      },
                    ],
                  },
                ],
                series: [
                  {
                    name: "speed",
                    data: series_data, // sample data
                    yAxis: 0,
                    allowPointSelect: true,
                    point: {
                      events: {
                        click: (event) => {
                          this.pointClick(event);
                        },
                        // mouseOver: (event) => {
                        //   console.log('mouseOver',event.target.x)
                        // },
                        // select: (event) => {
                        //    this.onPointSelect(event)
                        // },
                        // unselect: (event) => {
                        //   console.log('unselect',event.target.x)
                        // },
                      },
                    },
                  },
                  {
                    name: "distance",
                    data: dist_data,
                    yAxis: 1,
                    color: "#FF0000",
                    dashStyle: "shortdot",
                  },
                  {
                    name: "Vl1A",
                    data: Vl1A,
                    yAxis: 2,
                    color: "#FF4500",
                    visible: false,
                    // dashStyle: "shortdot",
                  },
                  {
                    name: "Vl2A",
                    data: Vl2A,
                    yAxis: 2,
                    color: "#FF4500",
                    visible: false,
                    // dashStyle: "shortdot",
                  },
                  {
                    name: "Vl3A",
                    visible: false,
                    data: Vl3A,
                    yAxis: 2,
                    color: "#FF4500",
                    // dashStyle: "shortdot",
                  },
                  {
                    name: "Vl1B",
                    data: Vl1B,
                    visible: false,
                    yAxis: 2,
                    color: "#FF4500",
                    // dashStyle: "shortdot",
                  },
                  {
                    name: "Vl2B",
                    data: Vl2B,
                    visible: false,
                    yAxis: 2,
                    color: "#FF4500",
                    // dashStyle: "shortdot",
                  },
                  {
                    name: "Vl3B",
                    data: Vl3B,
                    visible: false,
                    yAxis: 2,
                    color: "#FF4500",
                    // dashStyle: "shortdot",
                  },
                  {
                    name: "I1A",
                    data: I1A,
                    visible: false,
                    yAxis: 3,
                    color: "#0000FF",
                    // dashStyle: "shortdot",
                  },
                  {
                    name: "I2A",
                    data: I2A,
                    visible: false,
                    yAxis: 3,
                    color: "#0000FF",
                    // dashStyle: "shortdot",
                  },
                  {
                    name: "I3A",
                    data: I3A,
                    visible: false,
                    yAxis: 3,
                    color: "#0000FF",
                    // dashStyle: "shortdot",
                  },
                  {
                    name: "I1B",
                    data: I1B,
                    visible: false,
                    yAxis: 3,
                    color: "#0000FF",
                    // dashStyle: "shortdot",
                  },
                  {
                    name: "I2B",
                    data: I2B,
                    visible: false,
                    yAxis: 3,
                    color: "#0000FF",
                    // dashStyle: "shortdot",
                  },
                  {
                    name: "I3B",
                    data: I3B,
                    visible: false,
                    yAxis: 3,
                    color: "#0000FF",
                    // dashStyle: "shortdot",
                  },
                  {
                    name: "kWtA",
                    data: kWtA,
                    visible: false,
                    yAxis: 4,
                    color: "#FFA500",
                    // dashStyle: "shortdot",
                  },
                  {
                    name: "kWtB",
                    data: kWtB,
                    visible: false,
                    yAxis: 4,
                    color: "#FFA500",
                    // dashStyle: "shortdot",
                  },
                  {
                    name: "HzA",
                    data: HzA,
                    visible: false,
                    yAxis: 5,
                    color: "#FFA500",
                    // dashStyle: "shortdot",
                  },
                  {
                    name: "HzB",
                    data: HzB,
                    visible: false,
                    yAxis: 5,
                    color: "#FFA500",
                    // dashStyle: "shortdot",
                  },

                  {
                    name: "kWhImA",
                    data: kWhImA,
                    visible: true,
                    yAxis: 6,
                    color: "#00FF7F",
                    // dashStyle: "shortdot",
                  },
                  {
                    name: "kWhImB",
                    data: kWhImB,
                    visible: true,
                    yAxis: 6,
                    color: "#00FF7F",
                    // dashStyle: "shortdot",
                  },
                  {
                    name: "kWhExA",
                    data: kWhExA,
                    visible: false,
                    yAxis: 7,
                    color: "#9400D3",
                    // dashStyle: "shortdot",
                  },
                  {
                    name: "kWhExB",
                    data: kWhExB,
                    visible: false,
                    yAxis: 7,
                    color: "#9400D3",
                    // dashStyle: "shortdot",
                  },
                  {
                    name: "FuelA",
                    data: FuelA,
                    visible: true,
                    yAxis: 8,
                    color: "#FF00FF",
                    // dashStyle: "shortdot",
                  },
                  {
                    name: "FuelB",
                    data: FuelB,
                    visible: true,
                    yAxis: 8,
                    color: "#FF00FF",
                    // dashStyle: "shortdot",
                  },
                ],
              };
              //  this.csvurl = this.createCSV()
            });
          this.$refs.chart.chart.hideLoading();
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    onPointSelect(e) {
      console.log("select", e);
      // var chart = e.target.series.chart,
      //     lineWidth = 2,
      //     draggablePlotLine = chart.renderer.rect(e.target.x, chart.plotTop, lineWidth, chart.plotHeight)
      //     .attr({
      //       fill: 'blue'
      //     })
      //     .add()
      //     chart.container.onmousemove = function(e) {
      //     if (draggablePlotLine.drag) {
      //       let normalizedEvent = chart.pointer.normalize(e),
      //         extremes = {
      //           left: chart.plotLeft,
      //           right: chart.plotLeft + chart.plotWidth
      //         };
      //
      //       // Move line
      //       if (
      //         e.target.x >= extremes.left &&
      //         e.target.x <= extremes.right
      //       ) {
      //         draggablePlotLine.attr({
      //           x: e.target.x
      //         })
      //       }
      //     }
      //   }
      //
      //   draggablePlotLine.element.onmousedown = function() {
      //     draggablePlotLine.drag = true
      //   }
      //
      //   draggablePlotLine.element.onmouseup = function() {
      //     draggablePlotLine.drag = false
      //   }

      e.target.series.chart.xAxis[0].addPlotLine({
        id: 1,
        color: "#FF0000",
        width: 2,
        value: e.target.x,
      });
    },

    pointClick(event) {
      console.log(event);
      if (this.wasClicked) {
        event.point.series.chart.xAxis[0].addPlotLine({
          id: 2,
          color: "#FF0000",
          width: 2,
          value: event.point.x,
        });

        this.wasClicked = false;
        var curPt = _.find(this.dist, { time: event.point.x });
        var curDist = curPt.dist;
        var curTime = curPt.time;
        var distTravelled = curDist - this.prevDist;
        var timeTaken = curTime - this.prevTime;

        for (let i = 0; i < 1000; i++) {}
        var mps = window.prompt("Please enter thresold Speed", 80);
        if (mps) {
          // calulate total time travelled with mps
          var chartData = _.filter(this.chart_data, (o) => {
            return o.time >= this.prevTime && o.time <= curTime;
          });
          // console.log(chartData)
          var tTime = 0;
          var mpsDist = 0;
          if (chartData.length > 0) {
            var pTime = chartData[0].time;
            var pSpeed = chartData[0].speed;
            var pmpsDist = chartData[0].dist;

            for (let i = 1; i < chartData.length; i++) {
              var cTime = chartData[i].time;
              var cmpsDist = chartData[i].dist;
              var cSpeed = chartData[i].speed;
              if (pSpeed >= mps && cSpeed) {
                tTime = tTime + (cTime - pTime);
                mpsDist = mpsDist + (cmpsDist - pmpsDist);
              }
              pTime = chartData[i].time;
              pmpsDist = chartData[i].dist;
              pSpeed = chartData[i].speed;
            }
          }
          // var tTime = chartData.length * 3
          var timeMps = (distTravelled / mps) * 3600000;
          var loss_gain = this.round((timeMps - timeTaken) / 1000, 0);
          //           const msg = `* Loss/Gain: ${loss_gain} sec.
          // * run time above thresold ${this.round(tTime/1000,0)} sec.
          // * run time below thresold ${this.round((timeTaken -tTime)/1000,0)} sec.
          // * run time: ${this.round(timeTaken/1000,0)} sec.
          //
          // * run distance above thresold ${this.round(mpsDist,3)} Km.
          // * run distance below thresold ${this.round((distTravelled - mpsDist),3)} Km.
          // * run distance: ${this.round(distTravelled,3)} Km.
          // `

          const msg =
            "* Loss/Gain:" +
            loss_gain +
            " sec. <br/>" +
            "* run time above thresold " +
            this.round(tTime / 1000, 0) +
            " sec. <br/>" +
            "* run time below thresold " +
            this.round((timeTaken - tTime) / 1000, 0) +
            " sec. <br/>" +
            "* run time: " +
            this.round(timeTaken / 1000, 0) +
            " sec. <br/><br/>" +
            "* run distance above thresold " +
            this.round(mpsDist, 3) +
            " Km. <br/>" +
            "* run distance below thresold " +
            this.round(distTravelled - mpsDist, 3) +
            " Km. <br/>" +
            "* run distance: " +
            this.round(distTravelled, 3) +
            " Km.";

          this.msgAnnotations = {
            labels: [
              {
                point: {
                  x: event.point.x,
                  y: event.point.y,
                  yAxis: 0,
                  xAxis: 0,
                },
                text: msg,
              },
            ],
          };
          event.point.series.chart.addAnnotation(this.msgAnnotations);
          // alert(msg)
        }
      } else {
        event.point.series.chart.xAxis[0].removePlotLine(1);
        event.point.series.chart.xAxis[0].removePlotLine(2);
        // event.point.series.chart.removeAnnotation(this.msgAnnotations)
        event.point.series.chart.annotations.forEach((annotation) =>
          annotation.destroy()
        );
        event.point.series.chart.annotations.length = 0;
        event.point.series.chart.xAxis[0].addPlotLine({
          id: 1,
          color: "#FF0000",
          width: 2,
          value: event.point.x,
          draggableX: true,
        });
        // var newAnnotations = {
        //      shapes: [{
        //          points: [{ x: event.point.x, y: event.point.y }, { x: event.point.x + 200, y: event.point.y + 100 }, '1'],
        //          type: 'path',
        //          fill: 'none',
        //          stroke: 'red',
        //          markerStart: 'circle',
        //          markerEnd: 'custom-shape'
        //      }]
        //  }
        // event.point.series.chart.addAnnotation(newAnnotations)
        this.wasClicked = true;
        var prevPt = _.find(this.dist, { time: event.point.x });
        this.prevDist = prevPt.dist;
        this.prevTime = prevPt.time;
      }
    },
    round(value, precision) {
      var multiplier = Math.pow(10, precision || 0);
      return Math.round(value * multiplier) / multiplier;
    },
    getFormattedTime(t) {
      var lt = moment(t).format("YYYY-MM-DD HH:mm:ss");
      var testDateUtc = moment.utc(lt);
      var localDate = moment(testDateUtc).local();
      return localDate.format("DD/MM/YYYY");
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
    makeColor(colorNum, colors) {
      if (colors < 1) colors = 1; // defaults to one color - avoid divide by zero
      return "hsl(" + ((colorNum * (360 / colors)) % 360) + ",70%, 90%)";
    },
  },
};
</script>

<style>
.chartdiv {
  width: 100%;
  height: 100%;
  margin: 5px;
  overflow: auto;
}
</style>
